import React from 'react';

import './styles.scss';

const OnboardingTooltipContent: React.FC<{
  headerContent?: React.ReactNode;
  mainContent?: React.ReactNode;
}> = ({ headerContent, mainContent }) => {
  return (
    <>
      {headerContent && <div className="step-tooltip-top">{headerContent}</div>}
      {mainContent && <div className="step-tooltip-bottom">{mainContent}</div>}
    </>
  );
};

export default OnboardingTooltipContent;
